import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MobileBlockerComponent } from './mobile-blocker.component';
import { DirectivesModule } from '@shared/directives/directives.module';

@NgModule({
    imports: [CommonModule, TranslateModule, DirectivesModule],
    declarations: [MobileBlockerComponent],
    exports: [MobileBlockerComponent],
})
export class MobileBlockerComponentModule {}
